import { AppADGroup } from '../Apps';
import AppManagementRequest from './AppManagementRequest';

//AppADGroupXref : AppADGroup
export default class AppADGroupRequest extends AppManagementRequest {
	constructor(app, createdBy, AppADGroupXref) {
		super(app, createdBy);
		this.AppADGroupXref = AppADGroupXref
			? new AppADGroup(AppADGroupXref)
			: new AppADGroup();
	}
}
